import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractDocument.Delete.IRequest;
type Response = Api.Core.ContractDocument.Delete.IResponse;
type Headers = Api.Core.ContractDocument.Delete.IHeaders;
const url = '/api/Sales/Contract/:id/Documents/:documentId';
export default async function contractDocumentDeleteApi(params: {
  id: number;
  documentId: number;
}): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
